import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/hooks/useAuth';
import UserProfileDropdown from '../../../components/UserProfileDropdown/UserProfileDropdown';
import Logo_white from '../../../components/Logo/Logo';
import './QuizPage.css';

const QuizPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const userName = user?.name || 'Student';
  const userEmail = user?.email || 'student@pathbuddy.com';

  const iframeSrc = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
    ? 'http://localhost:5000/website-quiz/'
    : '/website-quiz/';

  return (
    <div className="quiz-page">
      <header className="quiz-header">
        <div className="quiz-header-content">
          <div className="quiz-left-section">
            <div className="quiz-logo">
              <h2><Logo_white onClick={() => navigate('/apps')} /></h2>
            </div>
          </div>
          
          <div className="quiz-header-actions" />
        </div>
      </header>

      <main className="quiz-main">
        <iframe 
          src={iframeSrc}
          style={{
            width: '100%',
            height: 'calc(100vh - 76px)',
            border: 'none',
            marginTop: '76px'
          }}
          title="Quiz Generator"
        />
      </main>
    </div>
  );
};

export default QuizPage;